import { ComponentProps, forwardRef, useCallback } from 'react';
import { FileInput as KitFileInput } from '@publicplan/kern-react-kit';

export type FileInputProps = ComponentProps<typeof KitFileInput>;

/**
 * File upload field in the KERN look.
 *
 * Works around a bug in @publicplan/kern-react-kit 1.3: its FileInput uses `id` for the
 * label's `for` attribute but does not put it on the `<input>` itself, so the label is not
 * associated with the field (WCAG 1.3.1 / 4.1.2) and error-summary links to `#id` go
 * nowhere. The id is set on the input element through the forwarded ref. Remove this
 * wrapper once the kit passes the id through.
 */
export const FileInput = forwardRef<HTMLInputElement, FileInputProps>(
  ({ id, ...props }, ref) => {
    const setRef = useCallback(
      (node: HTMLInputElement | null) => {
        if (node) node.id = id;
        if (typeof ref === 'function') ref(node);
        else if (ref) ref.current = node;
      },
      [id, ref],
    );
    return <KitFileInput {...props} id={id} ref={setRef} />;
  },
);
FileInput.displayName = 'FileInput';
